import { Component } from '@angular/core';
import { E5coreUiWorkTabBaseComponent } from './e5code-ui-work-tab-base';

@Component({
  selector: 'e5core-ui-work-tab-bootstrap',
  templateUrl: './e5core-ui-work-tab-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-tab-bootstrap.component.css']
})
export class E5coreUiWorkTabBootstrapComponent extends E5coreUiWorkTabBaseComponent {

}
